import { gql } from '@apollo/client';

export const SignInQuery = gql`
  mutation SignIn($input: AccountsSignInInput) {
    accounts {
      signIn(input: $input) {
        error
      }
    }
  }
`;
